// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"vL-z","carouselContainer":"wL-z"};